interface Response {
  [key: string]: string[]
}

export const errorToString = ({ response }: { response: Response }) => {
  if (!response) return ''
  const errors: string[] = Object.values(response).flat()
  return errors.join(', ')
}
